import { Injectable } from "@angular/core";
import { IResponseAPIObjeto } from "@models/responseAPI.interface";
import { ApiService } from "./api.service";
import { DangerError } from "@shared/errors/custom.error";
import { environment } from "@env/environment";

@Injectable({
	providedIn: "root",
})
export class DiaHabilService {
  private env = environment.env;

	constructor(private apiService: ApiService) {}

	// cantidad de días hábiles entre 2 fechas
	async obtenerDiasHabiles(fechaInicial: string, fechaFinal: string): Promise<{data: number, msg: string, success: boolean}> {
		const { data, msg, success } =
			await this.apiService.privatePost<IResponseAPIObjeto>(
				`grl-obtener-dias-habiles`,
				{ fechaInicial, fechaFinal }
			);
		if (!success) throw new DangerError(msg);
		return { data: Number(data as unknown), msg, success };
	}

	// fecha final hábil a partir de una fecha inicial + n días
	async obtenerFechaFinal(fechaInicial: string, cantDias: number): Promise<{data: string, msg: string, success: boolean}> {
		const { data, msg, success } =
			await this.apiService.privatePost<IResponseAPIObjeto>(
				`grl-obtener-fecha-final-habil`,
				{ fechaInicial, cantDias }
			);
		if (!success) throw new DangerError(msg);
		return { data: data as unknown as string, msg, success };
	}
}
